"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var constants_1 = require("./constants");
var staticAudioUrl = 'https://music.wixstatic.com/mp3'; // TODO add to topology
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps;
    var volume = compProps.volume, autoPlay = compProps.autoPlay, loop = compProps.loop;
    var uri = compData.uri, originalFileName = compData.originalFileName, track = compData.track, artist = compData.artist;
    var playlist = [
        {
            url: staticAudioUrl + "/" + uri,
            trackName: track,
            artistName: artist,
        },
    ];
    var ariaLabel = "Application, Audio player, " + track;
    return {
        volume: volume / 100,
        autoPlay: autoPlay,
        loop: loop,
        originalFileName: originalFileName,
        playlist: playlist,
        ariaLabel: ariaLabel,
    };
});
exports.css = withCompInfo_1.withCompInfo(['isMobileView', 'skin'], function (_a) {
    var isMobileView = _a.isMobileView, skin = _a.skin;
    var view = isMobileView ? 'mobile' : 'desktop';
    // NOTE: there are legacy sites which have "MusicPlayer" skin. Skin is not supported, an empty "div" will be rendered.
    if (typeof constants_1.SKIN_HEIGHT_MAP[skin] !== 'undefined') {
        return { height: constants_1.SKIN_HEIGHT_MAP[skin][view] };
    }
    return {};
});
//# sourceMappingURL=SingleAudioPlayer.js.map